import Vue from 'vue'
import VueRouter from 'vue-router'

import HomeView from '../views/Home/HomeView.vue'
import GuQianBiFuWuNeiRongView from '../views/GuQianBi/FuWuNeiRongView.vue'
import GuQianBiMianZeTiaoKuanView from '../views/GuQianBi/MianZeTiaoKuanView.vue'
import GuQianBiPeiFuBiaoZhunView from '../views/GuQianBi/PeiFuBiaoZhunView.vue'
import GuQianBiPingJiBiaoZhunView from '../views/GuQianBi/PingJiBiaoZhunView.vue'
import GuQianBiShouFeiBiaoZhunView from '../views/GuQianBi/ShouFeiBiaoZhunView.vue'
import JiZhiBiFuWuNeiRongView from '../views/JiZhiBi/FuWuNeiRongView.vue'
import JiZhiBiMianZeTiaoKuanView from '../views/JiZhiBi/MianZeTiaoKuanView.vue'
import JiZhiBiPeiFuBiaoZhunView from '../views/JiZhiBi/PeiFuBiaoZhunView.vue'
import JiZhiBiPingJiBiaoZhunView from '../views/JiZhiBi/PingJiBiaoZhunView.vue'
import JiZhiBiShouFeiBiaoZhunView from '../views/JiZhiBi/ShouFeiBiaoZhunView.vue'
import JiZhiBiXiaCiDaiMaView from '../views/JiZhiBi/XiaCiDaiMaView.vue'
import NewsGongGaoGongShiView from '../views/News/GongGaoGongShiView.vue'
import NewsGuanYuWoMenView from '../views/News/GuanYuWoMenView.vue'
import NewsPingJiLiuChengView from '../views/News/PingJiLiuChengView.vue'
import NewsRuHeSongPingView from '../views/News/RuHeSongPingView.vue'

import PeiFuGongShiView from '../views/News/PeiFuGongShiView.vue'
import PingJiJieGuoView from '../views/News/PingJiJieGuoView.vue'
import ZhanHuiShiJianBiaoView from '../views/News/ZhanHuiShiJianBiaoView.vue'

import ShowDetailView from '../views/Show/ShowDetailView.vue'
import ShowListView from '../views/Show/ShowListView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: HomeView
  },
  {
    path: '/GuQianBi/FuWuNeiRong',
    name: 'GuQianBiFuWuNeiRongView',
    component: GuQianBiFuWuNeiRongView
  },
  {
    path: '/GuQianBi/MianZeTiaoKuan',
    name: 'GuQianBiMianZeTiaoKuanView',
    component: GuQianBiMianZeTiaoKuanView
  },
  {
    path: '/GuQianBi/PeiFuBiaoZhun',
    name: 'GuQianBiPeiFuBiaoZhunView',
    component: GuQianBiPeiFuBiaoZhunView
  },
  {
    path: '/GuQianBi/PingJiBiaoZhun',
    name: 'GuQianBiPingJiBiaoZhunView',
    component: GuQianBiPingJiBiaoZhunView
  },
  {
    path: '/GuQianBi/ShouFeiBiaoZhun',
    name: 'GuQianBiShouFeiBiaoZhunView',
    component: GuQianBiShouFeiBiaoZhunView
  },
  {
    path: '/JiZhiBi/FuWuNeiRong',
    name: 'JiZhiBiFuWuNeiRongView',
    component: JiZhiBiFuWuNeiRongView
  },
  {
    path: '/JiZhiBi/MianZeTiaoKuan',
    name: 'JiZhiBiMianZeTiaoKuanView',
    component: JiZhiBiMianZeTiaoKuanView
  },
  {
    path: '/JiZhiBi/PeiFuBiaoZhun',
    name: 'JiZhiBiPeiFuBiaoZhunView',
    component: JiZhiBiPeiFuBiaoZhunView
  },
  {
    path: '/JiZhiBi/PingJiBiaoZhun',
    name: 'JiZhiBiPingJiBiaoZhunView',
    component: JiZhiBiPingJiBiaoZhunView
  },
  {
    path: '/JiZhiBi/ShouFeiBiaoZhun',
    name: 'JiZhiBiShouFeiBiaoZhunView',
    component: JiZhiBiShouFeiBiaoZhunView
  },
  {
    path: '/JiZhiBi/XiaCiDaiMa',
    name: 'JiZhiBiXiaCiDaiMaView',
    component: JiZhiBiXiaCiDaiMaView
  },
  {
    path: '/News/GongGaoGongShi',
    name: 'NewsGongGaoGongShiView',
    component: NewsGongGaoGongShiView
  },
  {
    path: '/News/GuanYuWoMen',
    name: 'NewsGuanYuWoMenView',
    component: NewsGuanYuWoMenView
  },
  {
    path: '/News/PingJiLiuCheng',
    name: 'NewsPingJiLiuChengView',
    component: NewsPingJiLiuChengView
  },
  {
    path: '/News/RuHeSongPing',
    name: 'NewsRuHeSongPingView',
    component: NewsRuHeSongPingView
  },
  {
    path: '/News/PeiFuGongShi',
    name: 'PeiFuGongShiView',
    component: PeiFuGongShiView
  },
  {
    path: '/News/PingJiJieGuo',
    name: 'PingJiJieGuoView',
    component: PingJiJieGuoView
  },
  {
    path: '/News/ZhanHuiShiJianBiao',
    name: 'ZhanHuiShiJianBiaoView',
    component: ZhanHuiShiJianBiaoView
  },
  {
    path: '/Show/ShowDetail',
    name: 'ShowDetailView',
    component: ShowDetailView
  },
  {
    path: '/Show/ShowList',
    name: 'ShowListView',
    component: ShowListView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
